import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";

export default function EditableText({
	tagName: Tag = "div",
	value,
	onChange,
	className,
	placeholder,
	editable = false,
	...props
}) {
	const [isEditing, setIsEditing] = useState(false);
	const [text, setText] = useState(value);
	const inputRef = useRef(null);

	useEffect(() => {
		setText(value);
	}, [value]);

	useEffect(() => {
		if (isEditing && inputRef.current) {
			inputRef.current.focus();
		}
	}, [isEditing]);

	const handleBlur = () => {
		setIsEditing(false);
		if (text !== value) {
			onChange(text);
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter" && !e.shiftKey) {
			e.preventDefault();
			handleBlur();
		}
		if (e.key === "Escape") {
			setText(value);
			setIsEditing(false);
		}
	};

	if (!editable) {
		return (
			<Tag className={className} {...props}>
				{value}
			</Tag>
		);
	}

	if (isEditing) {
		return (
			<Tag className={className} {...props}>
				<textarea
					ref={inputRef}
					value={text}
					onChange={(e) => setText(e.target.value)}
					onBlur={handleBlur}
					onKeyDown={handleKeyDown}
					className="bg-transparent border-none outline-none w-full h-full resize-none overflow-hidden text-inherit p-0 m-0 placeholder-white/20 focus:ring-0"
					placeholder={placeholder}
					rows={1}
					style={{ height: "auto", minHeight: "1.5em" }}
					onInput={(e) => {
						e.target.style.height = "auto";
						e.target.style.height = `${e.target.scrollHeight}px`;
					}}
				/>
			</Tag>
		);
	}

	return (
		<Tag
			className={`${className} cursor-text hover:outline hover:outline-1 hover:outline-cyan-500/50 rounded-sm transition-all`}
			onClick={(e) => {
				e.stopPropagation();
				setIsEditing(true);
			}}
			{...props}
		>
			{value || (
				<span className="opacity-40 italic">
					{placeholder || "Digite aqui..."}
				</span>
			)}
		</Tag>
	);
}

EditableText.propTypes = {
	tagName: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func,
	className: PropTypes.string,
	placeholder: PropTypes.string,
	editable: PropTypes.bool,
};
